import React, { useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { ROOT_FOLDER } from '../../customHooks/FileManager/useFolder';
import { folderType } from '../../customHooks/FileManager/useFolderTypes';
import { returnInputFieldLength } from '../../utils/commonFunctions';

type finalFolderDataType = {
  folder_name: string;
  parent_id: number | null;
  folder_path: "[]";
}

type AppProps = {
  isOpen: boolean;
  currentFolder: folderType | null;
  toggleAddFolderModal: () => void;
  handleCreateFolder: (data: any) => void;
}



const AddFolderModal = ({
  isOpen,
  toggleAddFolderModal,
  currentFolder,
  handleCreateFolder
}: AppProps) => {
  const [folderName, setFolderName] = useState<string>('');
  const [folderNameError, setFolderNameError] = useState<string>('');

  const handleFolderNameChange = (e: any) => {
    setFolderName(e.target.value);

    if (folderNameError) {
      setFolderNameError('');
    }
  }

  const handleAddFolder = (e: any) => {
    e.preventDefault();
    if (!folderName.length) {
      setFolderNameError('Folder name is required!');
    } else {
      if (currentFolder == null) {
        currentFolder=ROOT_FOLDER
        // return;
      }

      const finalPath = currentFolder?.full_path?.length ? JSON.parse(currentFolder?.full_path) : [];

      const path: any = [...finalPath];
      if (currentFolder !== ROOT_FOLDER) {
        path.push({
          name: currentFolder.name,
          id: currentFolder.id
        })
      }

      let finalData: finalFolderDataType = {
        folder_name: folderName.trim(),
        parent_id: currentFolder?.id,
        folder_path: currentFolder?.id===0?[]:path
      };

      handleCreateFolder(finalData);
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggleAddFolderModal}
    >
      <ModalHeader className="pt-4 pl-4">Add Folder</ModalHeader>
      <ModalBody className="pl-4 pr-4">
        <form>
          <div className="form-group mt-3">
            <div>
              <label htmlFor="foldername"
                className={folderName ? "active" : ""}
              >Enter Folder Name </label><span className="color-red">*</span>
              <input
                type="text"
                className={`form-control ${ !!folderNameError ? 'error-border' : null }`}
                name="text"
                value={folderName}
                autoFocus
                onChange={(e) => handleFolderNameChange(e)}
                maxLength={60}
                onKeyPress={(e: any) => e.key === 'Enter' ? handleAddFolder(e) : null}
              />
              {!!folderNameError && <small className="text-danger">{folderNameError}</small>}
            </div>
            <span className="input-length">{returnInputFieldLength(folderName?.length, 60)}</span>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <span className="pointer" onClick={toggleAddFolderModal}>Cancel</span>
        <Button color="primary ml-3" onClick={(e: any) => handleAddFolder(e)}>+ Add Folder</Button>
      </ModalFooter>
    </Modal>
  )
};

export default AddFolderModal;